export function RequiredMessages() {
  return {
    "string.base": `Campo requerido`,
    "string.empty": `Campo requerido`,
    "any.required": `Campo requerido`,
  };
}
export function NumberMessages() {
  return {
    "number.base": `Campo requerido`,
    "any.required": `Campo requerido`,
    "any.only": `Campo requerido`,
    "number.positive": `El campo debe ser númerico`,
    "number.min": `El campo debe ser minimo {#limit} digitos`,
    "number.max": `El campo debe ser maximo {#limit} digitos`,
  };
}
export function StringMessages() {
  return {
    "string.base": `Campo requerido`,
    "string.empty": `Campo requerido`,
    "string.min": `El campo debe ser minimo {#limit} characters`,
    "string.max": `El campo debe ser maximo {#limit} characters`,
    "string.email": `El campo debe ser a email valido`,
  };
}

export function UriMessages() {
  return {
    "string.uri": `El campo debe ser una URL valida`,
  };
}

export function RefMessages(match) {
  return {
    "any.only": `El campo debe ser match`,
  };
}

export function ArrayMessages() {
  return {
    "array.base": `Campo requerido`,
    "array.min": `Al menos un elemento es requerido`,
  };
}

export function AnyMessages() {
  return {
    "any.only": `Campo requerido`,
  };
}

export function setValidationMessages(dataType) {
  let messages = {};
  dataType.map((type) => {
    if (type === "string") messages = { ...messages, ...StringMessages() };
    if (type === "required") messages = { ...messages, ...RequiredMessages() };
    if (type === "number") messages = { ...messages, ...NumberMessages() };
    if (type === "ref") messages = { ...messages, ...RefMessages() };
    if (type === "uri") messages = { ...messages, ...UriMessages() };
    if (type === "array") messages = { ...messages, ...ArrayMessages() };
    if (type === "any") messages = { ...messages, ...AnyMessages() };

    return messages;
  });

  return Object.assign({}, messages);
}
